import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const UserProfileAdd = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.74992 5.00002C6.74992 3.75738 7.75728 2.75002 8.99992 2.75002C10.2426 2.75002 11.2499 3.75738 11.2499 5.00002C11.2499 6.24266 10.2426 7.25002 8.99992 7.25002C7.75728 7.25002 6.74992 6.24266 6.74992 5.00002ZM8.99992 1.25002C6.92885 1.25002 5.24992 2.92895 5.24992 5.00002C5.24992 7.07109 6.92885 8.75002 8.99992 8.75002C11.071 8.75002 12.7499 7.07109 12.7499 5.00002C12.7499 2.92895 11.071 1.25002 8.99992 1.25002ZM5.00026 11.25C2.92935 11.25 1.25049 12.9287 1.25026 14.9996L1.24992 17.9999C1.24987 18.4141 1.58562 18.75 1.99983 18.75C2.41405 18.7501 2.74987 18.4143 2.74992 18.0001L2.75026 14.9998C2.7504 13.7572 3.75771 12.75 5.00026 12.75H7.29167C7.70588 12.75 8.04167 12.4142 8.04167 12C8.04167 11.5858 7.70588 11.25 7.29167 11.25H5.00026ZM16.1667 8.33333C16.1667 7.91912 15.8309 7.58333 15.4167 7.58333C15.0025 7.58333 14.6667 7.91912 14.6667 8.33333V11.3335H11.6667C11.2525 11.3335 10.9167 11.6693 10.9167 12.0835C10.9167 12.4977 11.2525 12.8335 11.6667 12.8335H14.6667V15.8333C14.6667 16.2475 15.0025 16.5833 15.4167 16.5833C15.8309 16.5833 16.1667 16.2475 16.1667 15.8333V12.8335H19.1667C19.5809 12.8335 19.9167 12.4977 19.9167 12.0835C19.9167 11.6693 19.5809 11.3335 19.1667 11.3335H16.1667V8.33333Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default UserProfileAdd
